/* DON'T EDIT THIS FILE DIRECTLY, USE `add:constant` NPM SCRIPT */
export const ACCORDION = 'accordion';
export const ACTION = 'action';
export const ACTIONS = 'actions';
export const ACTIVE = 'active';
export const ALERT = 'alert';
export const ALIGN = 'align';
export const ANGLE = 'angle';
export const APP_LEVEL = 'app-level';
export const AREA = 'area';
export const AROUND = 'around';
export const ASC = 'asc';
export const AUTO = 'auto';
export const BACKDROP = 'backdrop';
export const BADGE = 'badge';
export const BADGE_ERROR = 'badge--error';
export const BADGE_INFO = 'badge--info';
export const BADGE_SUCCESS = 'badge--success';
export const BASELINE = 'baseline';
export const BETWEEN = 'between';
export const BLOCK = 'block';
export const BLUE = 'blue';
export const BODY = 'body';
export const BOTTOM_LEFT = 'bottom-left';
export const BOTTOM_MIDDLE = 'bottom-middle';
export const BOTTOM_RIGHT = 'bottom-right';
export const BRANDING = 'branding';
export const BTN = 'btn';
export const BUTTON = 'button';
export const CARD = 'card';
export const CARET = 'caret';
export const CELL = 'cell';
export const CELLS = 'cells';
export const CENTER = 'center';
export const CHECKBOX = 'checkbox';
export const CHILDREN = 'children';
export const CLICK = 'click';
export const CLICKABLE = 'clickable';
export const CLOSE = 'close';
export const CLR = 'clr';
export const COL = 'col';
export const COLLAPSE = 'collapse';
export const COLLAPSED = 'collapsed';
export const COLLAPSIBLE = 'collapsible';
export const COLUMN = 'column';
export const COMPACT = 'compact';
export const COMPLETE = 'complete';
export const CONTAINER = 'container';
export const CONTENT = 'content';
export const CONTROL = 'control';
export const CURRENT = 'current';
export const DANGER = 'danger';
export const DATAGRID = 'datagrid';
export const DESC = 'desc';
export const DESCRIPTION = 'description';
export const DETAIL = 'detail';
export const DIALOG = 'dialog';
export const DISABLED = 'disabled';
export const DIVIDER = 'divider';
export const DOWN = 'down';
export const DRAG = 'drag';
export const DRAGGABLE = 'draggable';
export const DROPDOWN = 'dropdown';
export const EMPTY = 'empty';
export const END = 'end';
export const ERROR = 'error';
export const EXPANDABLE = 'expandable';
export const EXPANDED = 'expanded';
export const FADE = 'fade';
export const FADE_DOWN = 'fadeDown';
export const FILTER = 'filter';
export const FILTERED = 'filtered';
export const FIRST = 'first';
export const FIXED = 'fixed';
export const FLASH = 'flash';
export const FLEX = 'flex';
export const FOOTER = 'footer';
export const FORM = 'form';
export const FORMS = 'forms'; // DIRT: Why not "form"? Beats me!
export const GROUP = 'group';
export const HANDLE = 'handle';
export const HANDLER = 'handler';
export const HAS = 'has';
export const HEADER = 'header';
export const HIGHLIGHT = 'highlight';
export const HORIZONTAL = 'horizontal';
export const HOST = 'host';
export const ICON = 'icon';
export const ICONS = 'icons';
export const IMAGE = 'image';
export const IMG = 'img';
export const IN = 'in';
export const INACTIVE = 'inactive';
export const INFO = 'info';
export const INLINE = 'inline';
export const INNER = 'inner';
export const INPUT = 'input';
export const INVERSE = 'inverse';
export const IS = 'is';
export const ITEM = 'item';
export const ITEMS = 'items';
export const JUSTIFY = 'justify';
export const LABEL = 'label';
export const LABELED = 'labeled';
export const LAST = 'last';
export const LEFT = 'left';
export const LEFT_BOTTOM = 'left-bottom';
export const LEFT_MIDDLE = 'left-middle';
export const LEFT_TOP = 'left-top';
export const LG = 'lg';
export const LIGHT_BLUE = 'light-blue';
export const LINK = 'link';
export const LIST = 'list';
export const LOOP = 'loop';
export const MAIN = 'main';
export const MASTER = 'master';
export const MD = 'md';
export const MEDIA = 'media';
export const MENU = 'menu';
export const MODAL = 'modal';
export const NAV = 'nav';
export const NEXT = 'next';
export const NOBORDER = 'noborder';
export const NODE = 'node';
export const NUMBER = 'number';
export const OFFSET = 'offset';
export const ON = 'on';
export const OPEN = 'open';
export const ORANGE = 'orange';
export const ORDER = 'order';
export const OUTLINE = 'outline';
export const OUTSIDE = 'outside';
export const OVERFLOW = 'overflow';
export const PAGINATION = 'pagination';
export const PANEL = 'panel';
export const PLACEHOLDER = 'placeholder';
export const POINTER = 'pointer';
export const POPOVER = 'popover';
export const PREVIOUS = 'previous';
export const PRIMARY = 'primary';
export const PROGRESS = 'progress';
export const PURPLE = 'purple';
export const RADIO = 'radio';
export const RESET = 'reset';
export const RIGHT = 'right';
export const RIGHT_BOTTOM = 'right-bottom';
export const RIGHT_MIDDLE = 'right-middle';
export const RIGHT_TOP = 'right-top';
export const ROW = 'row';
export const SCROLLABLE = 'scrollable';
export const SCROLLING = 'scrolling';
export const SEARCH = 'search';
export const SECONDARY = 'secondary';
export const SELECT = 'select';
export const SELECTED = 'selected';
export const SELF = 'self';
export const SEPARATOR = 'separator';
export const SIDENAV = 'sidenav';
export const SIGNPOST = 'signpost';
export const SM = 'sm';
export const SOLID = 'solid';
export const SORT = 'sort';
export const SPINNER = 'spinner';
export const STACK = 'stack';
export const START = 'start';
export const STATUS = 'status';
export const STEP = 'step';
export const STEPPER = 'stepper';
export const STRETCH = 'stretch';
export const SUBMIT = 'submit';
export const SUBNAV = 'subnav';
export const SUBTEXT = 'subtext';
export const SUCCESS = 'success';
export const SWITCH = 'switch';
export const TABLE = 'table';
export const TABS = 'tabs';
export const TEXT = 'text';
export const TEXTAREA = 'textarea';
export const TITLE = 'title';
export const TOGGLE = 'toggle';
export const TOOLTIP = 'tooltip';
export const TOP_LEFT = 'top-left';
export const TOP_MIDDLE = 'top-middle';
export const TOP_RIGHT = 'top-right';
export const TREE = 'tree';
export const TREENODE = 'treenode'; // DIRT: Clarity bug: tree-node vs treenode.
export const TRIGGER = 'trigger';
export const UNSTYLED = 'unstyled';
export const UP = 'up';
export const VALIDATE = 'validate';
export const VERTICAL = 'vertical';
export const VIEW = 'view';
export const WARNING = 'warning';
export const WRAP = 'wrap';
export const WRAPPER = 'wrapper';
export const XL = 'xl';
export const XS = 'xs';
